import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';
import Assignment from './Assignments';
import AssignmentV4 from './AssignmentsV4';
import AssignmentsResponsive from './AssignmentsResponsive/AssignmentResponsive';

const AssignmentAreaToggle = (props) => {
  const { assignmentPageMuiV6202501, webAppFtResponsiveAssignments202607 } =
    useFlags();

  if (webAppFtResponsiveAssignments202607) {
    return <AssignmentsResponsive />;
  }

  return assignmentPageMuiV6202501 ? (
    <Assignment {...props} />
  ) : (
    <AssignmentV4 {...props} />
  );
};

export default AssignmentAreaToggle;
